// @ts-nocheck
import {t} from 'ttag';
import {useSnackbar} from 'notistack';
import React from 'react';
import {Card, CardContent, CardHeader} from '@mui/material';
import {Attachments} from '../../../../../components/attachments';
import {STATUSES} from '@components/status/Status';
import RTKQueryFeedback from '../../../../../components/common/RTKQueryFeedback';
import AttachmentsDownloads from './refund-attachments-download/AttachmentsDownloads';
import {useAddAttachmentsMutation, useGetAttachmentsQuery} from '../../../../../store/apis/ccs';
import AttachmentsDownloadsSkeleton from './refund-attachments-download/AttachmentsDownloadsSkeleton';
import {Divider, Typography} from "@mui/material";

const AttachmentsRefundView = ({ state, refundId }) => {
  const { data: dataAttachments, isLoading: isLoadingAttachments } =
    useGetAttachmentsQuery(refundId);
  const [addAttachments, { error, isLoading }] =
    useAddAttachmentsMutation();

  // eslint-disable-next-line
  const { enqueueSnackbar } = useSnackbar();
  return (
    <Card elevation={3}>
      <CardHeader
        title={<Typography sx={{fontFamily: 'OpenSansMedium'}}>{t`Attachments`}</Typography>}
      />
      <Divider/>
      <CardContent>
        <Attachments
          dropAttachmentsLabel={t`Drop Attachments`}
          allowedFileTypesLabel={t`Allowed File Types`}
          error={false}
          disabled={(state !== STATUSES.PROCESSED.name) && (state !== STATUSES.PENDING.name)}
          onFilesRejected={(files) => {
            files.map((f) => {
              const successMessage = `${f.name}: ${f.reason}`;
              return enqueueSnackbar(successMessage, { variant: 'error' });
            });
          }}
          onSizeLimitReached={(files) => {
            files.map((f) => {
              const successMessage = `${f.name}: ${f.reason}`;
              return enqueueSnackbar(successMessage, { variant: 'error' });
            });
          }}
          onLoadFiles={(files) => {
            addAttachments({refundId, files:files});
          }}
        />
        {isLoadingAttachments && <AttachmentsDownloadsSkeleton />}
        {!isLoadingAttachments && <AttachmentsDownloads refundId={refundId} attachments={dataAttachments}/>}
      </CardContent>
      <RTKQueryFeedback error={error} isLoading={isLoading} />
    </Card>
  );
};

export default AttachmentsRefundView;
